import { formatMusicoInstrumentosText } from './musicoInstrumentos';
import {
  downloadBrandedListadoExcel,
  downloadBrandedListadoPdf,
} from './exportListadoBranded';

const LIST_TITLE = 'Listado de músicos';
const COLUMNS = ['#', 'Nombre', 'Apellidos', 'Instrumentos', 'Teléfono', 'Email', 'Estado'];

export function musicosToExportRows(musicos) {
  return (musicos || []).map((m, idx) => [
    idx + 1,
    m.nombre || '',
    m.apellidos || '',
    formatMusicoInstrumentosText(m, '; '),
    m.telefono || '',
    m.email || '',
    m.activo ? 'Activo' : 'Inactivo',
  ]);
}

const PDF_COLUMN_STYLES = {
  0: { cellWidth: 8 },
  1: { cellWidth: 28 },
  2: { cellWidth: 28 },
  3: { cellWidth: 62 },
  4: { cellWidth: 28 },
  5: { cellWidth: 42 },
  6: { cellWidth: 16 },
};

const EXCEL_COL_WIDTHS = [
  { wch: 4 },
  { wch: 18 },
  { wch: 18 },
  { wch: 36 },
  { wch: 14 },
  { wch: 28 },
  { wch: 10 },
];

/**
 * @param {{ musicos: object[], bandName?: string, subtitle?: string, filename?: string }} params
 */
export async function downloadMusicosListadoPdf({ musicos, bandName, subtitle, filename }) {
  const rows = musicosToExportRows(musicos);
  await downloadBrandedListadoPdf({
    listTitle: LIST_TITLE,
    columns: COLUMNS,
    rows,
    bandName,
    subtitle,
    filename,
    columnStyles: PDF_COLUMN_STYLES,
    defaultFilenamePrefix: 'musicos',
  });
}

/**
 * @param {{ musicos: object[], bandName?: string, subtitle?: string, filename?: string }} params
 */
export async function downloadMusicosListadoExcel({ musicos, bandName, subtitle, filename }) {
  const rows = musicosToExportRows(musicos);
  return downloadBrandedListadoExcel({
    listTitle: LIST_TITLE,
    columns: COLUMNS,
    rows,
    bandName,
    subtitle,
    filename,
    sheetName: 'Músicos',
    colWidths: EXCEL_COL_WIDTHS,
    defaultFilenamePrefix: 'musicos',
  });
}
